import React from 'react';
import Icon from '../../../components/AppIcon';

const AllInOneSection = () => {
  const components = [
    {
      icon: 'Battery',
      title: 'Batterij (GRP Graphene)',
      description: 'Grafeentechnologie — maximale levensduur en veiligheid.',
      color: 'bg-primary/10',
      iconColor: 'text-primary',
    },
    {
      icon: 'Cpu',
      title: 'Bidirectionele omvormer',
      description: 'Geleverd en geconfigureerd door gecertificeerde installateurs.',
      color: 'bg-blue-50',
      iconColor: 'text-blue-600',
    },
    {
      icon: 'Settings',
      title: 'EMS — slim laden',
      description: 'Automatisch laden op de goedkoopste momenten.',
      color: 'bg-amber-50',
      iconColor: 'text-amber-600',
    },
    {
      icon: 'Wrench',
      title: 'Professionele installatie',
      description: 'Inclusief inbedrijfstelling door gecertificeerde monteurs.',
      color: 'bg-green-50',
      iconColor: 'text-green-600',
    },
    {
      icon: 'Monitor',
      title: 'Klantenportaal',
      description: 'Realtime inzicht via Verduurzaamwijzer.nu.',
      color: 'bg-purple-50',
      iconColor: 'text-purple-600',
    },
  ];

  const timeline = [
    { step: '1', label: 'Adviesgesprek', icon: 'MessageCircle' },
    { step: '2', label: 'Offerte op maat', icon: 'FileText' },
    { step: '3', label: 'Installatie in 1 dag', icon: 'Wrench' },
    { step: '4', label: 'Monitoring via portaal', icon: 'Monitor' },
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center space-x-2 text-primary bg-primary/10 px-3 py-1.5 rounded-full text-xs font-heading font-semibold uppercase tracking-wider mb-4">
            <Icon name="Package" size={12} />
            <span>Alles-in-één pakket</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-foreground leading-tight">
            Van adviesgesprek tot werkende batterij — wij regelen alles
          </h2>
          <p className="mt-4 font-body text-muted-foreground">
            Dit is niet een doos met een batterij. Dit is een werkend systeem aan je muur, inclusief alles wat erbij hoort.
          </p>
        </div>

        {/* Components checklist — asymmetric bento */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {components?.map((comp, i) => (
            <div
              key={comp?.title}
              className={`rounded-2xl border border-border bg-white p-6 shadow-elevation-1 hover:shadow-elevation-2 transition-shadow ${i === 4 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
            >
              <div className={`w-11 h-11 ${comp?.color} rounded-xl flex items-center justify-center mb-4`}>
                <Icon name={comp?.icon} size={20} className={comp?.iconColor} />
              </div>
              <h3 className="font-heading font-bold text-foreground mb-1">{comp?.title}</h3>
              <p className="text-sm font-body text-muted-foreground">{comp?.description}</p>
            </div>
          ))}
        </div>

        {/* Process timeline — horizontal */}
        <div className="bg-white border border-border rounded-2xl p-8 shadow-elevation-1 mb-8">
          <h3 className="text-sm font-heading font-semibold text-muted-foreground uppercase tracking-wider mb-6 text-center">Hoe het werkt</h3>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 sm:gap-0">
            {timeline?.map((item, i) => (
              <React.Fragment key={item?.step}>
                <div className="flex flex-col items-center text-center flex-1">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-3 relative">
                    <Icon name={item?.icon} size={20} className="text-primary" />
                    <div className="absolute -top-1 -right-1 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                      <span className="text-[10px] font-heading font-bold text-primary-foreground">{item?.step}</span>
                    </div>
                  </div>
                  <p className="text-sm font-heading font-semibold text-foreground">{item?.label}</p>
                </div>
                {i < timeline?.length - 1 && (
                  <div className="hidden sm:block flex-shrink-0 mx-2">
                    <Icon name="ChevronRight" size={20} className="text-muted-foreground/40" />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Installer note */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-primary/5 border border-primary/20 rounded-xl p-5">
          <div className="flex items-start space-x-3">
            <Icon name="ShieldCheck" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <p className="text-sm font-body text-foreground">
              <strong>ZekerZon</strong> — gecertificeerd installateur, ervaren, landelijk werkend. [Certificeringen te bevestigen]
            </p>
          </div>
          <button
            onClick={() => scrollTo('formulier')}
            className="flex-shrink-0 px-5 py-2.5 bg-primary text-primary-foreground font-heading font-semibold text-sm rounded-md hover:bg-primary/90 transition-colors"
          >
            Plan adviesgesprek
          </button>
        </div>
      </div>
    </section>
  );
};

export default AllInOneSection;
